import { gql } from "@/services/httpAdapter";

export const onUpdateCallActivity = gql`
	subscription onUpdateCallActivity($locationId: String, $commissionCycleId: String) {
		onUpdateCallActivity(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			_id
			locationId
			commissionCycleId
		}
	}
`;
